import { useState } from "react";
import { useAuth } from "../hooks/AuthContext";
import { useGetTasks } from "../hooks/useTaskApi";
import { TaskList } from "../components/tasks/TaskList";
import { HrTaskCreation } from "../components/tasks/HrTaskCreation";
import EmployeeTaskCreation from "../components/tasks/EmployeeTaskCreation";
import Container from "../components/ui/Container";
import { useParams } from "react-router-dom";
import Loader from "../components/ui/Loader";

export default function TaskCreatePage() {
  const [page, setPage] = useState(1);
  const limit = 10;
  const { user } = useAuth();
  const { projectId } = useParams();

  // ✅ HR tasks (via React Query) - pass user info
  const { data: taskData,isLoading, isError } = useGetTasks(page, limit, user);
  const TaskData = taskData?.tasks || [];
  const totalPages = taskData?.pages || 1;

  // ✅ Pagination handler (HR and Employee share page)
  const onPageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  return (
    <Container>
    {/* --- Role-based task creation --- */}
    {user?.role === "employee" ? (
      <EmployeeTaskCreation />
    ) : (
      <>
        <HrTaskCreation projectId={projectId} />
        <hr className="my-8" />
      </>
    )}

    {/* --- Loading State --- */}
    {isLoading ? (
      <Loader />
    ) : isError ? (
      <div className="text-center text-red-500 py-8">
        Error loading tasks. Please try again.
      </div>
    ) : TaskData.length === 0 ? (
      <div className="text-center text-gray-500 py-8">
        No tasks found.
      </div>
    ) : (
      /* --- Task List --- */
      <TaskList
        tasks={TaskData}
        statusFilter={["pending", "to-do", "hold", "in-progress"]}
        paginationData={{ page, pages: totalPages }}
        onPageChange={onPageChange}
      />
    )}
  </Container>
  );
}
